<section class="auth-page">

  <div class="auth-orb auth-orb--1"></div>
  <div class="auth-orb auth-orb--2"></div>

  <div class="auth-canvas">
    <div class="auth-card">

      <div class="auth-card-header">
        <a routerLink="/">
          <img src="assets/images/Logo ver 1.png" alt="Radwa Khallaf" class="auth-logo" />
        </a>
        <div class="auth-ornament">
          <span class="auth-orn-rule"></span>
          <span class="auth-orn-gem">✦</span>
          <span class="auth-orn-rule"></span>
        </div>
        <span class="auth-step-label">Reset Password</span>
      </div>

      <form class="auth-form">
        <div class="form-group-lux">
          <label for="resetCode">Enter Code</label>
          <input id="resetCode" [(ngModel)]="code" name="code" type="text" class="lux-input" />
        </div>

        <div class="form-group-lux">
          <label for="newPassword">New Password</label>
          <input id="newPassword" [(ngModel)]="password" name="password" type="password" class="lux-input" />
        </div>

        <button type="button" (click)="submit()" class="btn-auth">Send</button>
      </form>

    </div>
  </div>

</section>
